import React from "react";
import { Button, IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";
import StdExportImportData from "./stdImportExport";

function InOutReadingTable({ 
  initialColumns, 
  data, 
  setData, 
  srNo = false, 
  deletedRowIds, 
  setDeletedRowIds 
}) {
  const [columns, setColumns] = React.useState(initialColumns);

  // Handle data change
  const handleDataChange = (rowIndex, accessor, value) => {
    const newData = [...data];
    newData[rowIndex][accessor] = value;
    setData(newData); // Update parent state
  };

  // Add new row
  const handleAddRow = () => {
    const newRow = columns.reduce((acc, column) => {
      acc[column.accessor] = column.dataType === "number" ? 0 : "";
      return acc;
    }, {});
    setData([...data, newRow]);
  };

  // Handle delete row
  const handleDeleteRow = (rowIndex) => {
    const rowToDelete = data[rowIndex];
    
    // If row has an id, store it in the deletedRowIds state
    if (rowToDelete.id) {
      setDeletedRowIds((prev) => [...prev, rowToDelete.id]);
    }

    // Remove row from table
    const newData = data.filter((_, index) => index !== rowIndex);
    setData(newData);
  };

  // Handle column label change
  const handleColumnLabelChange = (columnIndex, value) => {
    const newColumns = [...columns];
    newColumns[columnIndex].label = value;
    setColumns(newColumns);
  };

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
     {/* Buttons at the top right */}
     <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
       <StdExportImportData
        setData={setData}
        data={data}
      />      
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={handleAddRow}
        >
          + Add Row
        </Button>
      </div>

      {/* Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          border: "1px solid black",
        }}
      >
        <thead>
          <tr>
            {srNo && (
              <th
                style={{
                  padding: "2px",
                  border: "1px solid black",
                  backgroundColor: "#f4f4f4",
                  textAlign: "center",
                }}
              >
                Sr.No
              </th>
            )}
            {columns.map((column, index) => (
              <th
                key={column.id}
                style={{
                  padding: "2px",
                  border: "1px solid black",
                  backgroundColor: "#f4f4f4",
                  textAlign: "center",
                }}
              >
                <input
                  type="text"
                  value={column.label}
                  onChange={(e) => handleColumnLabelChange(index, e.target.value)}
                  style={{
                    width: "100%",
                    padding: "2px",
                    boxSizing: "border-box",
                    border: "none",
                    backgroundColor: "transparent",
                    textAlign: "center",
                  }}
                />
              </th>
            ))}
            {/* Delete Column Header */}
            <th
              style={{
                padding: "2px",
                border: "1px solid black",
                backgroundColor: "#f4f4f4",
                textAlign: "center",
                width: "40px",
              }}
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {srNo && (
                <td
                  style={{
                    padding: "2px",
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {rowIndex + 1}
                </td>
              )}
              {columns.map((column) => (
                <td
                  key={column.id}
                  style={{
                    padding: "2px",
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {column.dataType === "select" ? (
                    <select
                      value={row[column.accessor]}
                      onChange={(e) =>
                        handleDataChange(rowIndex, column.accessor, e.target.value)
                      }
                      style={{
                        width: "100%",
                        padding: "2px",
                        boxSizing: "border-box",
                        textAlign: "center",
                      }}
                    >
                      {column.options.map((option) => (
                        <option key={option.label} value={option.label}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={column.dataType === "number" ? "number" : "text"}
                      value={row[column.accessor]}
                      onChange={(e) =>
                        handleDataChange(rowIndex, column.accessor, e.target.value)
                      }
                      style={{
                        width: "100%",
                        padding: "2px",
                        boxSizing: "border-box",
                        textAlign: "center",
                      }}
                    />
                  )}
                </td>
              ))}
              {/* Delete Button */}
              <td
                style={{
                  padding: "2px",
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                <IconButton
                  size="small"
                  onClick={() => handleDeleteRow(rowIndex)}
                  color="error"
                >
                  <Delete fontSize="small" />
                </IconButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default InOutReadingTable;
